import { useContainer } from './useContainer';

import { createLoginContainer } from '../app.state/createLoginContainer';

export function useLoginContainer() {
  return useContainer(createLoginContainer);
}
